import React, { useState, useEffect } from 'react';
import {
    FaMapMarkerAlt, FaEnvelope, FaPhone, FaFacebookF,
    FaLinkedinIn, FaTwitter, FaYoutube, FaClock, FaCheckCircle
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { API_URL } from '../config/api';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        nom_complet: '',
        entreprise: '',
        telephone: '',
        email: '',
        sujet: '',
        message: ''
    });

    const [submitted, setSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);

    // Scroll Animation Effect
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);

        const animatedElements = document.querySelectorAll('.scroll-animate');
        animatedElements.forEach(el => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                    source: 'site_web'
                })
            });

            const data = await response.json();

            if (response.ok && data.success) {
                setSubmitted(true);
                setFormData({
                    nom_complet: '',
                    entreprise: '',
                    telephone: '',
                    email: '',
                    sujet: '',
                    message: ''
                });

                setTimeout(() => {
                    setSubmitted(false);
                }, 5000);
            } else {
                throw new Error(data.message || 'Erreur lors de l\'envoi');
            }
        } catch (err) {
            console.error('Erreur:', err);
            setError(err.message || 'Une erreur est survenue. Veuillez réessayer.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Header />
            <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .contact-page {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          background: #fafafa;
          min-height: 100vh;
        }

        /* Scroll Animations */
        .scroll-animate {
          opacity: 0;
          transform: translateY(40px);
          transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), 
                      transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .scroll-animate.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .scroll-animate:nth-child(2) { transition-delay: 0.1s; }
        .scroll-animate:nth-child(3) { transition-delay: 0.2s; }

        /* Hero Section */
        .contact-hero {
          position: relative;
          height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600') center/cover;
        }

        .contact-hero::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(26, 32, 44, 0.75);
          backdrop-filter: blur(2px);
        }

        .contact-hero::after {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(135deg, rgba(26, 61, 47, 0.97) 0%, rgba(58, 151, 113, 0.1) 100%);
        }

        .contact-hero-content {
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          position: relative;
          z-index: 2;
          text-align: center;
          color: white;
          animation: fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1);
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .contact-hero-title {
          font-size: 56px;
          font-weight: 700;
          margin-bottom: 20px;
          letter-spacing: -0.5px;
          line-height: 1.1;
        }

        .contact-hero-subtitle {
          font-size: 20px;
          font-weight: 400;
          opacity: 0.95;
          line-height: 1.6;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Main Content */
        .contact-main {
          max-width: 1280px;
          margin: -80px auto 80px;
          padding: 0 24px;
          position: relative;
          z-index: 10;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 40px;
          align-items: start;
        }

        /* Contact Info Card */
        .contact-info-card {
          background: white;
          border-radius: 20px;
          padding: 48px 40px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          border: 1px solid rgba(0, 0, 0, 0.05);
          position: sticky;
          top: 100px;
          transition: box-shadow 0.3s ease;
        }

        .contact-info-card:hover {
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
        }

                .contact-info-title {
                    font-size: 28px;
                    font-weight: 700;
                    color: #1a202c;
                    margin-bottom: 12px;
                }
                    .button-content {
          display: inline-flex;
          align-items: center;
          gap: 12px;
        }

                .contact-info-subtitle {
                    font-size: 15px;
                    color: #718096;
                    margin-bottom: 40px;
                    line-height: 1.6;
                }

                .contact-info-items {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                    margin-bottom: 40px;
                }

                .contact-info-item {
                    display: flex;
                    gap: 20px;
                    align-items: flex-start;
                    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .contact-info-item:hover {
                    transform: translateX(8px);
                }

                .contact-info-icon {
                    width: 56px;
                    height: 56px;
                    border-radius: 12px;
                    background: #f7fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    color: #fd7e14;
                    flex-shrink: 0;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .contact-info-item:hover .contact-info-icon {
                    background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
                    color: white;
                    transform: scale(1.05);
                    box-shadow: 0 4px 12px rgba(253, 126, 20, 0.3);
                }

                .contact-info-content {
                    flex: 1;
                }

                .contact-info-label {
                    font-size: 12px;
                    font-weight: 600;
                    color: #a0aec0;
                    text-transform: uppercase;
                    letter-spacing: 0.8px;
                    margin-bottom: 6px;
                }

                .contact-info-value {
                    font-size: 16px;
                    color: #2d3748;
                    font-weight: 500;
                    line-height: 1.6;
                }

                .contact-info-value a {
                    color: inherit;
                    text-decoration: none;
                    transition: color 0.3s ease;
                }

                .contact-info-value a:hover {
                    color: #fd7e14;
                }

                /* Social Links */
                .contact-social {
                    padding-top: 32px;
                    border-top: 1px solid #e2e8f0;
                }

                .contact-social-title {
                    font-size: 12px;
                    font-weight: 600;
                    color: #a0aec0;
                    margin-bottom: 16px;
                    text-transform: uppercase;
                    letter-spacing: 0.8px;
                }

                .contact-social-links {
                    display: flex;
                    gap: 12px;
                    flex-wrap: wrap;
                }

                .social-link {
                    width: 44px;
                    height: 44px;
                    border-radius: 10px;
                    background: #f7fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #718096;
                    text-decoration: none;
                    font-size: 18px;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .social-link:hover {
                    background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
                    color: white;
                    transform: translateY(-3px);
                    box-shadow: 0 4px 12px rgba(253, 126, 20, 0.3);
                }

                /* Contact Form Card */
                .contact-form-card {
                    background: white;
                    border-radius: 20px;
                    padding: 48px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
                    border: 1px solid rgba(0, 0, 0, 0.05);
                    transition: box-shadow 0.3s ease;
                }

                .contact-form-card:hover {
                    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
                }

                .form-title {
                    font-size: 32px;
                    font-weight: 700;
                    color: #1a202c;
                    margin-bottom: 12px;
                }

                .form-subtitle {
                    font-size: 16px;
                    color: #718096;
                    margin-bottom: 36px;
                    line-height: 1.6;
                }

                /* Error Message */
                .error-message {
                    padding: 16px;
                    margin-bottom: 24px;
                    background: #fee2e2;
                    border: 2px solid #ef4444;
                    border-radius: 12px;
                    color: #991b1b;
                    font-size: 14px;
                    font-weight: 600;
                }

                .contact-form {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .form-row {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 20px;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                }

                .form-label {
                    font-size: 14px;
                    font-weight: 600;
                    color: #2d3748;
                }

                .form-required {
                    color: #dc3545;
                }

                .form-input,
                .form-textarea {
                    padding: 14px 18px;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 15px;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    background: #fafafa;
                }

                .form-input:focus,
                .form-textarea:focus {
                    outline: none;
                    border-color: #fd7e14;
                    background: white;
                    box-shadow: 0 0 0 3px rgba(253, 126, 20, 0.08);
                }

                .form-textarea {
                    min-height: 160px;
                    resize: vertical;
                }

                .form-submit {
                    padding: 16px 40px;
                    background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
                    color: white;
                    border: none;
                    border-radius: 10px;
                    font-size: 16px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 12px;
                    margin-top: 12px;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                    box-shadow: 0 4px 12px rgba(253, 126, 20, 0.3);
                }

                .form-submit:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(253, 126, 20, 0.4);
                }

                .form-submit:active:not(:disabled) {
                    transform: translateY(0);
                }

                .form-submit:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .spinner {
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }

                /* Success Message */
                .success-message {
                    position: fixed;
                    top: 100px;
                    right: 24px;
                    background: white;
                    padding: 20px 28px;
                    border-radius: 12px;
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    animation: slideInFromRight 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    z-index: 1000;
                    border-left: 4px solid #fd7e14;
                }

                @keyframes slideInFromRight {
                    from {
                        opacity: 0;
                        transform: translateX(100px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }

                .success-icon {
                    width: 48px;
                    height: 48px;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 24px;
                }

                .success-content h4 {
                    font-size: 16px;
                    font-weight: 700;
                    color: #1a202c;
                    margin-bottom: 4px;
                }

                .success-content p {
                    font-size: 14px;
                    color: #718096;
                }

                /* Map Section */
                .contact-map {
                    margin-top: 80px;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
                    height: 500px;
                    position: relative;
                    border: 1px solid rgba(0, 0, 0, 0.05);
                }

                .contact-map iframe {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    display: block;
                }

                /* Responsive */
                @media (max-width: 968px) {
                    .contact-hero {
                        height: 400px;
                    }

                    .contact-hero-title {
                        font-size: 42px;
                    }

                    .contact-hero-subtitle {
                        font-size: 18px;
                    }

                    .contact-main {
                        margin-top: -60px;
                    }

                    .contact-grid {
                        grid-template-columns: 1fr;
                        gap: 32px;
                    }

                    .contact-info-card {
                        position: static;
                    }

                    .contact-form-card {
                        padding: 36px 28px;
                    }

                    .form-row {
                        grid-template-columns: 1fr;
                    }

                    .success-message {
                        right: 16px;
                        left: 16px;
                    }
                }

                @media (max-width: 640px) {
                    .contact-hero {
                        height: 350px;
                    }

                    .contact-hero-title {
                        font-size: 32px;
                    }

                    .contact-hero-subtitle {
                        font-size: 16px;
                    }

                    .contact-main {
                        margin-top: -40px;
                        padding: 0 16px;
                    }

                    .contact-info-card {
                        padding: 32px 24px;
                    }

                    .contact-form-card {
                        padding: 28px 20px;
                    }

                    .form-title {
                        font-size: 26px;
                    }

                    .contact-map {
                        height: 350px;
                        margin-top: 60px;
                    }
                }
            `}</style>

            <div className="contact-page">
                {/* Hero Section */}
                <section className="contact-hero">
                    <div className="contact-hero-content">
                        <h1 className="contact-hero-title">Contactez-nous</h1>
                        <p className="contact-hero-subtitle">
                            CINEF est prêt à vous accompagner dans vos projets de formation.
                            Notre équipe est à votre écoute pour répondre à toutes vos questions.
                        </p>
                    </div>
                </section>

                {/* Main Content */}
                <main className="contact-main">
                    <div className="contact-grid">
                        {/* Contact Info */}
                        <div className="contact-info-card scroll-animate">
                            <h2 className="contact-info-title">Nos Coordonnées</h2>
                            <p className="contact-info-subtitle">
                                Nous sommes disponibles pour échanger sur vos besoins en formation.
                            </p>

                            <div className="contact-info-items">
                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Adresse Principale</div>
                                        <div className="contact-info-value">
                                            Jalan Cempaka Wangi No 22<br />
                                            Jakarta - Indonesia
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <FaEnvelope />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Email</div>
                                        <div className="contact-info-value">
                                            <a href="mailto:info@cinef-bj.com">info@cinef-bj.com</a><br />
                                            <a href="mailto:contact@cinef-bj.com">contact@cinef-bj.com</a>
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <FaPhone />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Téléphone</div>
                                        <div className="contact-info-value">
                                            <a href="tel:+22963186060">+229 63 18 60 60</a><br />
                                            <span>Fax: +229 21 20 02 20</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-info-icon">
                                        <FaClock />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Horaires</div>
                                        <div className="contact-info-value">
                                            Lun - Ven : 08h00 - 18h00<br />
                                            Sam : 09h00 - 13h00
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-social">
                                <div className="contact-social-title">Suivez-nous</div>
                                <div className="contact-social-links">
                                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                                        <FaFacebookF />
                                    </a>
                                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                                        <FaLinkedinIn />
                                    </a>
                                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                                        <FaTwitter />
                                    </a>
                                    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link">
                                        <FaYoutube />
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="contact-form-card scroll-animate">
                            <h2 className="form-title">Envoyez-nous un message</h2>
                            <p className="form-subtitle">
                                Remplissez le formulaire ci-dessous et notre équipe vous répondra dans les plus brefs délais.
                            </p>

                            {/* Affichage des erreurs */}
                            {error && (
                                <div className="error-message">
                                    {error}
                                </div>
                            )}

                            <form onSubmit={handleSubmit} className="contact-form">
                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Nom complet <span className="form-required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="nom_complet"
                                            className="form-input"
                                            placeholder="Votre nom"
                                            value={formData.nom_complet}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">Entreprise</label>
                                        <input
                                            type="text"
                                            name="entreprise"
                                            className="form-input"
                                            placeholder="Nom de l'entreprise"
                                            value={formData.entreprise}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label className="form-label">Téléphone</label>
                                        <input
                                            type="tel"
                                            name="telephone"
                                            className="form-input"
                                            placeholder="+229 XX XX XX XX"
                                            value={formData.telephone}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label className="form-label">
                                            Email <span className="form-required">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="form-input"
                                            placeholder="votre@email.com"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        Sujet <span className="form-required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="sujet"
                                        className="form-input"
                                        placeholder="Objet de votre message"
                                        value={formData.sujet}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        Message <span className="form-required">*</span>
                                    </label>
                                    <textarea
                                        name="message"
                                        className="form-textarea"
                                        placeholder="Décrivez votre demande en détail..."
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="form-submit"
                                    disabled={isSubmitting}
                                >
                                    <span className="button-content">
                                        {/* {isSubmitting ? (
                                            <FaSpinner />
                                        ) : (
                                            <FaPaperPlane />
                                        )} */}
                                        {isSubmitting ? 'Envoi en cours...' : 'Envoyer le message'}
                                    </span>
                                </button>
                            </form>
                        </div>
                    </div>

                    {/* Map */}
                    <div className="contact-map scroll-animate">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.0!2d2.3912!3d6.3654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x10235405e3c7d7c1%3A0xb827c09f27e8e6e3!2sCINEF%20FORMATION%20PROFESSIONNELLE%20AU%20BENIN!5e0!3m2!1sfr!2sbj!4v1700000000000!5m2!1sfr!2sbj"
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Localisation CINEF Formation Professionnelle au Bénin"
                        />
                    </div>
                </main>

                {/* Success Message */}
                {submitted && (
                    <div className="success-message">
                        <div className="success-icon">
                            <FaCheckCircle />
                        </div>
                        <div className="success-content">
                            <h4>Message envoyé avec succès !</h4>
                            <p>Nous vous répondrons dans les plus brefs délais.</p>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default ContactPage;